import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import {
  SelectApplicationModal,
  DepartmentUserModal,
  UnitAddModal,
  DepartmentNewModal,
  DepartmentUnitModal,
} from 'src/modules/features/admin/modals';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-invoice-row',
  templateUrl: './invoice-row.component.html',
  styleUrls: ['./invoice-row.component.scss'],
})
export class InvoiceRowComponent implements OnInit {
  collapseEquipment: boolean = true;
  pending: boolean;
  // baseUrl = environment;
  @Input() department: any;
  @Output() onDownload: EventEmitter<any> = new EventEmitter();
  @Output() onView: EventEmitter<any> = new EventEmitter();
  @Output() onPayNow: EventEmitter<any> = new EventEmitter();
  units: Array<any> = [];
  constructor(private modalService: SuiModalService) {}
  // units: Array<any> = [ { name: 'Sample Unit', description: 'sample desc' } ];
  newUser() {
    this.modalService
      .open(
        new DepartmentUserModal('Assign User to Department', '', ModalSize.Tiny)
      )
      .onApprove((payload) => {})
      .onDeny(() => {});
  }

  assignApp() {
    this.modalService
      .open(
        new SelectApplicationModal(
          'Assign Application to Department',
          '',
          ModalSize.Tiny
        )
      )
      .onApprove((payload) => {})
      .onDeny(() => {});
  }

  ngOnInit(): void {}
  toggleEquipment() {
    this.collapseEquipment = !this.collapseEquipment;
    this.collapseEquipment == false ? this.getEquipments() : '';
    this.units = [{ name: 'Sample Unit', description: 'sample desc' }];
    // 	setTimeout(()=>{
    // console.log(this.collapseEquipment);
    // 	this.collapseEquipment == false ? this.getEquipments() : '';
    // 	},500)
  }
  getEquipments() {}
}
